var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileAttechIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.324,
    height: 34.951,
    viewBox: "0 0 35.324 34.951",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    transform: "translate(-2.305 -2.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2305",
    "data-name": "Group 2305",
    transform: "translate(10.446 2.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11786",
    "data-name": "Path 11786",
    d: "M26.819,10.914V2.5H9.963A1.276,1.276,0,0,0,8.688,3.775V37.451H35.871v-25.9H27.457A.638.638,0,0,1,26.819,10.914ZM12.49,6.393h9.257a.638.638,0,0,1,0,1.275H12.49a.638.638,0,1,1,0-1.275ZM30.065,33.558H11.215a.638.638,0,0,1,0-1.275h18.85a.638.638,0,0,1,0,1.275Zm1.275-6.473H12.49a.638.638,0,1,1,0-1.275H31.34a.638.638,0,1,1,0,1.275Zm0-6.472H12.49a.638.638,0,1,1,0-1.275H31.34a.638.638,0,1,1,0,1.275Zm.638-7.109a.638.638,0,0,1-.638.638H12.49a.638.638,0,1,1,0-1.275H31.34A.637.637,0,0,1,31.978,13.5Z",
    transform: "translate(-8.688 -2.5)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11787",
    "data-name": "Path 11787",
    d: "M23.9,3v7.139h7.139Z",
    transform: "translate(-4.497 -2.362)",
    fill: "#707070"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_11788",
    "data-name": "Path 11788",
    d: "M9.173,4.41V32.356L2.388,8.083a1.273,1.273,0,0,1,.791-1.658Z",
    transform: "translate(0 0.526)",
    fill: "#707070"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileAttechIcon);
export default __webpack_public_path__ + "static/media/fileAttech_icon.4620e356f9d36e18a6640e85908b7a42.svg";
export { ForwardRef as ReactComponent };